import httpClient from '@/utils/httpClient'
import type { TemplateVariable } from '../types'

const templateVariablesService = {
  fetchTemplateVariables: async (templateId: string): Promise<Record<string, TemplateVariable>> => {
    const response = await httpClient.get<TemplateVariable[]>(`/v1/templates/${templateId}/template_variables`)
    const templateVariables: Record<string, TemplateVariable> = {}
    response.data.forEach(templateVariable => {
      templateVariables[templateVariable.code] = templateVariable
    })
    return templateVariables
  },
}

export default templateVariablesService
